export default {
  methods: {
      toggleKeyboard () {
          const input = document.querySelector('input.hidden-keyboard-input')
          if (input) {
              input.focus()
          }
      }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/toggleKeyboard.js